import { getEmaSmoothingEnabled, getGaussianSmoothingEnabled } from 'common/featureFlag';

/**
 * ema: exponential weighted moving average, causal
 * gaussian: gaussian filter, centered
 * causal: simple moving average, only preceding values taken into average: https://en.wikipedia.org/wiki/Causal_filter
 * centered: simple moving average, the same number of preceding and succeding values is averaged.
 */
export type SmoothingAlgorithm = 'emaCausal' | 'gaussianCentered' | 'smaCausal' | 'smaCentered';

export const smoothingAlgorithmsOrder: SmoothingAlgorithm[] = getEmaSmoothingEnabled()
  ? ([
      'emaCausal',
      'gaussianCentered',
      'smaCausal',
      'smaCentered',
    ] as const satisfies SmoothingAlgorithm[])
  : ([
      'smaCausal', // If EMA is disabled, we want to show causal at the top and make it the default.
      'smaCentered',
      'gaussianCentered',
    ] as const satisfies SmoothingAlgorithm[]);

export const SMOOTHING_ALGORITHM_ENABLED: Record<SmoothingAlgorithm, boolean> = {
  emaCausal: getEmaSmoothingEnabled(),
  gaussianCentered: getGaussianSmoothingEnabled(),
  smaCausal: true,
  smaCentered: true,
} as const;

export const DEFAULT_SMOOTHING_ALGORITHM: SmoothingAlgorithm = smoothingAlgorithmsOrder[0];

export const smoothingAlgorithmDisplayNames: Record<SmoothingAlgorithm, string> = {
  emaCausal: 'EMA Causal',
  gaussianCentered: 'Gaussian Centered',
  smaCausal: 'SMA Causal',
  smaCentered: 'SMA Centered',
} as const;
